export default __webpack_public_path__ + "static/media/fiveStart.b29ffe32.png";